// extracted by mini-css-extract-plugin
module.exports = {"link":"FindAppButton_link__kJs_M","qrCode":"FindAppButton_qrCode__e3cFq"};